import React from 'react';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { Toaster } from '@/components/ui/sonner';
import '@/App.css';

import { AuthProvider, useAuth } from '@/context/AuthContext';
import { ThemeProvider } from '@/context/ThemeContext';
import { ProtectedRoute } from '@/components/ProtectedRoute';
import AppLayout from '@/components/AppLayout';

import LoginPage from '@/pages/Login';
import ForgotPasswordPage from '@/pages/ForgotPassword';
import ResetPasswordPage from '@/pages/ResetPassword';
import ChangePasswordPage from '@/pages/ChangePassword';
import AdminDashboard from '@/pages/AdminDashboard';
import UserDashboard from '@/pages/UserDashboard';
import UsersPage from '@/pages/UsersPage';
import SpacesPage from '@/pages/SpacesPage';
import AssignmentsPage from '@/pages/AssignmentsPage';
import SpaceExplorer from '@/pages/SpaceExplorer';
import SpaceStatsPage from '@/pages/SpaceStats';
import JobsPage from '@/pages/JobsPage';
import DropletsPage from '@/pages/DropletsPage';
import DropletDetail from '@/pages/DropletDetail';
import DropletAssignmentsPage from '@/pages/DropletAssignmentsPage';

function DashboardSwitch() {
    const { user } = useAuth();
    if (!user || user === true) return null;
    return user.role === 'admin' ? <AdminDashboard /> : <UserDashboard />;
}

function App() {
    return (
        <ThemeProvider>
            <BrowserRouter>
                <AuthProvider>
                    <Routes>
                        {/* Public */}
                        <Route path="/login" element={<LoginPage />} />
                        <Route path="/forgot-password" element={<ForgotPasswordPage />} />
                        <Route path="/reset-password" element={<ResetPasswordPage />} />

                        {/* Protected shell */}
                        <Route
                            element={
                                <ProtectedRoute>
                                    <AppLayout />
                                </ProtectedRoute>
                            }
                        >
                            <Route path="/" element={<DashboardSwitch />} />
                            <Route path="/spaces" element={<SpacesPage />} />
                            <Route
                                path="/users"
                                element={
                                    <ProtectedRoute adminOnly>
                                        <UsersPage />
                                    </ProtectedRoute>
                                }
                            />
                            <Route
                                path="/assignments"
                                element={
                                    <ProtectedRoute adminOnly>
                                        <AssignmentsPage />
                                    </ProtectedRoute>
                                }
                            />
                            <Route
                                path="/jobs"
                                element={
                                    <ProtectedRoute adminOnly>
                                        <JobsPage />
                                    </ProtectedRoute>
                                }
                            />
                            <Route path="/explorer/:id" element={<SpaceExplorer />} />
                            <Route path="/explorer/:id/stats" element={<SpaceStatsPage />} />
                            <Route path="/droplets" element={<DropletsPage />} />
                            <Route path="/droplets/:id" element={<DropletDetail />} />
                            <Route
                                path="/droplet-assignments"
                                element={
                                    <ProtectedRoute adminOnly>
                                        <DropletAssignmentsPage />
                                    </ProtectedRoute>
                                }
                            />
                            <Route path="/change-password" element={<ChangePasswordPage />} />
                            <Route path="*" element={<Navigate to="/" replace />} />
                        </Route>
                    </Routes>
                    <Toaster position="bottom-right" />
                </AuthProvider>
            </BrowserRouter>
        </ThemeProvider>
    );
}

export default App;
